export enum WindowPosition {
  BottomRight = 0,
  TopRight = 1,
}
